export class CollectionCountAppModel {
	public collectionName: string;
	public count: number;

	public constructor(collectionName: string, count: number) {
		this.collectionName = collectionName;
		this.count = count;
	}
}
